// 전역 네임스페이스 객체 생성
window.$j = {};

// 모듈 임포트 및 초기화 함수
const initModule = (path) => {
    const ModuleClass = require(`./${path}`).default;
    const inst = new ModuleClass();

    // ✅ 인스턴스에 모듈 경로 태깅(열거 안 되게)
    Object.defineProperty(inst, '__j_path', {
        value: path,
        enumerable: false,
        configurable: false
    });

    return inst;
};
// static 클래스 로더 함수 (인스턴스화 X, 클래스 그 자체 반환)
const initStaticModule = (path) => {
    return require(`./${path}`).default;
};

// Sites Bootstrap 로더(정적)
function loadSiteBootstrap(pageType) {
    try {
        return initStaticModule(`Sites/${pageType}/Bootstrap`);
    } catch (e) {
        console.warn(`No site bootstrap: Sites/${pageType}/Bootstrap`, e);
        return null;
    }
}



// Core 모듈 초기화
$j.Core = {
    Config: initStaticModule('Core/Config')
};

// Common 모듈 초기화
$j.Common = {
    EventBus: initModule('Common/EventBus'),
    Store: initStaticModule('Common/Store'),   // 쿠키·localStorage·sessionStorage 단일 통로
    Util: initStaticModule('Common/Util'),
    Form: initStaticModule('Common/Form'),      // 폼 헬퍼(셀렉트·입력포맷·핸들러) — blade 는 $j.Common.Form.* 로 부른다
    Network: initModule('Common/Network'),
    Csrf: initStaticModule('Common/Csrf'),      // CSRF 토큰 자동첨부(jQuery·fetch·XHR) — 모든 사이트 공통
    FillToggle: initModule('Common/FillToggle'),
    SystemUi: initModule('Common/SystemUi'),  // 시스템 공통 오버레이(배너·로딩) 런타임 주입
    Mobiscroll: initStaticModule('Common/Mobiscroll'), // mobiscroll 전역 기본값(달력 '오늘' 버튼)
};
// 어떤 스크립트가 요청을 쏘기 전에 — 전송 계층(jQuery·fetch·XHR)에 CSRF 토큰 자동첨부를 건다(동기).
$j.Common.Csrf.install();
// 페이지 스크립트가 달력을 만들기 전에 — mobiscroll 은 모든 사이트에서 main.js 보다 먼저 로드된다
$j.Common.Mobiscroll.applyDefaults();

// Ui 모듈 초기화
$j.Ui = {
    BS: initModule('Ui/BS'),
    Swipe: initModule('Ui/Swipe'),
    Div: initModule('Ui/Div'),
    Layer: initModule('Ui/Layer'),   // 공용 오버레이 스택(z-index) 매니저
    Modal: initModule('Ui/Modal'),   // 공용 모달 엔진(center/sheet/full) — 사이트별 테마는 scss
    JBModal: initModule('Ui/JBModal'),
    Tooltip: initModule('Ui/Tooltip'),
    Toast: initModule('Ui/Toast'),
    AmountKor: initModule('Ui/AmountKor'), // 금액칸 말풍선 '6만 9천원' — input 에 data-amount-kor
    BankField: initModule('Ui/BankField'), // 은행 선택 칸 — 쓰는 사이트가 shared/components/bank-field 를 import 한다
    Dialog: initModule('Ui/Dialog'), // 확인·알림 다이얼로그 — swalert 가 여기로 위임한다
    DebugLog: initModule('Ui/DebugLog'), // 개발자용 화면 로그 오버레이(앱 웹뷰엔 콘솔이 없다) — 사용자 알림은 Toast

    ZoomPhoto: initModule('Ui/ZoomPhoto'),
    CardNews: initModule('Ui/CardNews'), // 카드뉴스 뷰어 — **넘겨받은 묶음만** 읽는다(ZoomPhoto 는 화면의 사진을 전부 모은다)
    FullFrame: initModule('Ui/FullFrame'), // 전체화면 iframe 레이어(지도·이미지편집기)
    PullRefresh: initModule('Ui/PullRefresh'),
    InfiniteScroll: initModule('Ui/InfiniteScroll'), // 목록 '더보기'를 스크롤 자동로드로
    FabHide: initModule('Ui/FabHide'),     // 플로팅 버튼 밀어서 숨기기(캡쳐 방해 방지)
    ScrollFade: initModule('Ui/ScrollFade'), // 가로 스크롤 '더 있다' 힌트(페이드+셰브론) — 쓰는 사이트 부트스트랩이 attachAll()
    EdgeTab: initModule('Ui/EdgeTab'),     // 가장자리 탭 — 관리자 복귀 알약 · AI 발주 버튼
    DevicePicker: initModule('Ui/DevicePicker'), // 디바이스 사진 그리드 피커 (앱 push → web 렌더) — **모바일 일지 전용**(F/Upload.pickPhotos 머리말)
};

// Features 모듈 초기화
$j.F = {
    // 앱 업데이트 게이트 — 장비불러(/m)·악덕알리미(/b) 공용 (사이트별 옵션은 각 Bootstrap 이 넘긴다)
    AppGate: initModule('F/AppGate'),
    App: initModule('F/AppBridge'),      // 앱 브릿지(안드로이드·iOS 공용). $j.F.Android 는 아래 영구 별칭
    // 장비불러 앱(JB) 웹뷰 연동 흐름 — 같은 앱을 띄우는 /m·/ma 가 함께 쓴다 (브리지는 $j.F.App)
    JbApp: initModule('F/JbApp'),
    Popup: initModule('F/Popup'),        // 전체팝업(공지/약관개정) — Bootstrap 에서 start()
    Chat: initModule('F/Chat/Index'),
    Car: initModule('F/Car'),
    CarSelect: initModule('F/CarSelect'),
    Inicis: initModule('F/Inicis'),
    Social: initModule('F/Social'),
    SmsAuth: initModule('F/SmsAuth'),
    KakaoMap: initModule('F/KakaoMap'),
    Postcode: initModule('F/Postcode'),
    ModalPhone: initModule('F/Phone'),
    Upload: initModule('F/Upload'),
    CardReceipt: initModule('F/CardReceipt'), // 카드결제 전표 마크업 — 앱·관리자·불러톡 공유 이미지 공용 (.ui-receipt)
    Member: {
        ModalSafetySign: initModule('F/Member/Modal/SafetySign'),
        ModalCarOption: initModule('F/Member/Modal/CarOption'),
    },
    ImageEditor: initModule('F/ImageEditor'),
    // 일지 공통 컴포넌트만 F/ 에 유지. 페이지 스크립트(Main·Calendar)와 렌더러(ListRenderer)는
    // 일지 전용이라 Pages/Mobile/Diary/ (=m.js) 로 이관 — 등록은 그쪽 register.js 가 담당.
    Diary: {
        DiaryPhotoHub: initModule('F/Diary/DiaryPhotoHub'),
        DiaryJobs: initModule('F/Diary/DiaryJobs'),
        DiaryDocs: initModule('F/Diary/DiaryDocs'),
        PaymentModal: initModule('F/Diary/PaymentModal'),
        TaxBill: initModule('F/Diary/TaxBill'),
        // 일지 카드 하단 BS — 구 Diary/Main.js 전역 함수에서 분리
        CashLog: initModule('F/Diary/CashLog'),
        ExpenseForm: initModule('F/Diary/ExpenseForm'),
        WorkMemo: initModule('F/Diary/WorkMemo'),
        CancelChoice: initModule('F/Diary/CancelChoice'),
        DocShareSheet: initModule('F/Diary/DocShareSheet'),
    },
    Order: {
        Info: initModule('F/Order/Info'),
        // 오더 상세 모달 (모바일 공용) — 캐시내역·-6차 등에서 공유
        Biz: initModule('F/Order/Biz'),
        Gallery: initModule('F/Order/Gallery'),
        // 오더목록 DataTable/검색필터 — 관리자(/adm/orders)·협력사(/p/orders) 공용
        ListTable: initStaticModule('F/Order/ListTable'),
        SearchOpt: initStaticModule('F/Order/SearchOpt'),
        CarDetail: initStaticModule('F/Order/CarDetail'),    // 업종 셀렉트 > 기종 상세검색 3단 모달
        SearchHelp: initStaticModule('F/Order/SearchHelp'),   // 현장/메모 통합검색 도움 레이어
    },
    Partner: {
        // 협력사(/p/) 상단바 정보변경 모달 — 두 오더목록 화면이 레이아웃을 공유한다
        InfoModal: initStaticModule('F/Partner/InfoModal'),
    },
    Baljoo: {
        ModalAiChat: initModule('F/Baljoo/Modal/AiChat'),
        ModalCarType: initModule('F/Baljoo/Modal/CarType'),
        ModalConfirm: initModule('F/Baljoo/Modal/Confirm'),
        ModalHowLong: initModule('F/Baljoo/Modal/HowLong'),
        ModalHowToPay: initModule('F/Baljoo/Modal/HowToPay'),
        ModalSign: initModule('F/Baljoo/Modal/Sign'),
        ModalChangePriceIntro: initModule('F/Baljoo/Modal/ChangePriceIntro'),
        ModalWorkDay: initModule('F/Baljoo/Modal/WorkDay'),
        ModalPrice: initModule('F/Baljoo/Modal/Price'),
        ModalWorkDayTime: initModule('F/Baljoo/Modal/WorkDayTime'),
        ModalWorkTime: initModule('F/Baljoo/Modal/WorkTime'),
        ModalOption: initModule('F/Baljoo/Modal/Option'),
        ModalOptionCrane: initModule('F/Baljoo/Modal/Option/Crane'),
        ModalOptionExcavator: initModule('F/Baljoo/Modal/Option/Excavator'),
        ModalOptionForklift: initModule('F/Baljoo/Modal/Option/Forklift'),
        ModalOptionLadder: initModule('F/Baljoo/Modal/Option/Ladder'),
        ModalOptionLift: initModule('F/Baljoo/Modal/Option/Lift'),
        ModalOptionSky: initModule('F/Baljoo/Modal/Option/Sky'),
    },
    Mobile: {
        Layout: initModule('F/Mobile/Layout'),
        Theme: initModule('F/Mobile/Theme'),  // 화면모드/글자크기 런타임 토글 (첫 반영은 <head> 부트 스크립트 — ThemeBoot)
        NoticeBS: initModule('F/Mobile/NoticeBS'),  // 공지 상세 BottomSheet
        VnumSheet: initModule('F/Mobile/VnumSheet'), // 가상번호 설정 BS (서류등록·위치설정 공용)
        OrderSheet: initModule('F/Mobile/OrderSheet'), // 오더 상세 BS — 작업내용 + 그 오더의 내역 모아보기 (수주포인트)
        LocationGate: initModule('F/Mobile/LocationGate'), // 수발주자 위치정보 동의 + GPS 권한 게이트 (알림 진입 시 1회)
        ProxyBar: initModule('F/Mobile/ProxyBar'), // 모바일관리자(/ma) 대리진입 중 '관리자 복귀' 알약
        SiteSwitch: initModule('F/Mobile/SiteSwitch'), // CS 만 보이는 '관리자'(/ma) 전환 알약 — 반대편은 /ma 부트스트랩
        // 앱 연동 흐름은 여기 없다 — /ma 도 같은 앱이라 $j.F.JbApp(F/ 직속)으로 올렸다.
        // 로그인 직후 묶음(history clear·설정동기화·위치게이트·팝업)은 Sites/Mobile/Bootstrap 이 직접 기술.
    },
    Docs: {
        v1: {
            Index:       initModule('F/Docs/v1/Index'),
            Detail:      initModule('F/Docs/v1/Detail'),
            UploadSheet: initModule('F/Docs/v1/UploadSheet'),
        },
    },
    Admin: {
        Notification: initModule('F/Admin/Notification'),
        ChatPanel: initModule('F/Admin/ChatPanel'),   // 불러톡 인라인 패널 (구 admin.js openChatPanel 등)
        TableConfig: initModule('F/Admin/TableConfig'), // DataTables 전역 기본값 — 생성자에서 동기 설정 (구 admin.js)
        MasterCalendar: initModule('F/Admin/MasterCalendar'), // 마스터플랜 캘린더 — 입력화면·주간업무보고서 공용
        Devil: {
            Report: initModule('F/Admin/Devil/Report'),
            Master: initModule('F/Admin/Devil/Master'),
            Case: initModule('F/Admin/Devil/Case'),
            TestCall: initModule('F/Admin/Devil/TestCall'),
        },
        TaskGuard: initStaticModule('F/Admin/TaskGuard'),   // 처리창 겹침 가드 (원장 조회 → 확인 → 자동 맡기)
        TaskOpen:  initStaticModule('F/Admin/TaskOpen'),    // 원장이 지목한 건 (?open=N) 을 집어 화면이 연다
        TaskBadge: initStaticModule('F/Admin/TaskBadge'),   // 처리창 머리줄의 공통 칩 (담당·상태·이력·맡기)
        Collusion: {
            Case: initModule('F/Admin/Collusion/Case'),   // 부정발주 판정 모달 (제재관리·알림 모아보기 공용)
        },
        AutoComplete: initModule('F/Admin/AutoComplete'),
        CardPay: {
            ReceiptShare: initStaticModule('F/Admin/CardPay/ReceiptShare'), // 전표 불러톡 공유 — send(paymentNum) 하나로 끝남
        },
        Counsel: initModule('F/Admin/Counsel'),
        Menu: initModule('F/Admin/Menu'),
        StoreLinks: initModule('F/Admin/StoreLinks'), // 사이드바 스토어 팝오버 (장비불러·머큐리·악덕 스토어 주소)
        ProfileAvatar: initModule('F/Admin/ProfileAvatar'), // 관리자 프로필 바꾸기(이모지 아바타·사진) — 헤더 드롭다운
        MatchTag: initStaticModule('F/Admin/MatchTag'), // 매칭 유형 표기 통일 (NC/NS + ver)
        Theme: initModule('F/Admin/Theme'),  // 화면설정 3축(화면모드/글자크기/테마) 런타임 토글 (첫 반영은 <head> 부트 스크립트 — ThemeBoot)
        Util: initStaticModule('F/Admin/Util'),
        Member: {
            BaljooCntForm: initModule('F/Admin/Member/BaljooCntForm'),
            CarDrivers:    initModule('F/Admin/Member/CarDrivers'), // 기사 / 장비 관리 모달 (구 F/Admin/MemberCars)
            CmsForm:       initModule('F/Admin/Member/CmsForm'),
            Find:          initModule('F/Admin/Member/Find'),
            IdChangeForm:  initModule('F/Admin/Member/IdChangeForm'),
            ListTable:     initStaticModule('F/Admin/Member/ListTable'),
            Logs:          initStaticModule('F/Admin/Member/Logs'),  // 변경내역·로그인기록 모달 (기사편집·회원 팝오버 공용)
            Pop:           initStaticModule('F/Admin/Member/Pop'),   // 회원 액션 팝오버 (관리자 공용)
            Msix:          initModule('F/Admin/Member/Msix'),
            Penalty:       initModule('F/Admin/Member/Penalty'),
            FeeWay:        initModule('F/Admin/Member/FeeWay'),  // 회비결제방식 창 (기사편집 ⚙ — 다섯 갈래를 한 곳에서)
            FeeHistory:    initModule('F/Admin/Member/FeeHistory'), // 회비 내역 (기사편집 [내역] — 달마다 받는 길 · 청구액 · 낸 돈)
            Leave:         initModule('F/Admin/Member/Leave'),   // 탈퇴신청 처리창 (탈퇴목록·알림 모아보기 공용)
            PrepayForm:    initModule('F/Admin/Member/PrepayForm'),
            PrepayLog:     initModule('F/Admin/Member/PrepayLog'),
            SearchModal:   initModule('F/Admin/Member/SearchModal'),
            CarSearchModal: initStaticModule('F/Admin/Member/CarSearchModal'), // 차량 검색 설정 모달 — 기사관리·기사검색 공용
            Sosok:         initModule('F/Admin/Member/Sosok'),
            TransferForm:  initModule('F/Admin/Member/TransferForm'),
        },
        Order: {
            MatchLevelChart: initModule('F/Admin/Order/MatchLevelChart'),
            MatchPercent:    initModule('F/Admin/Order/MatchPercent'),
            BaljoojaForm:    initModule('F/Admin/Order/BaljoojaForm'),
            OrderListModal:  initStaticModule('F/Admin/Order/OrderListModal'),
            WhanHold:        initModule('F/Admin/Order/WhanHold'),   // 환원보류 기간임박 처리창 (알림 모아보기)
        },
        OutMember: {
            EditForm: initStaticModule('F/Admin/OutMember/EditForm'),
        },
        BoardPostForm: initStaticModule('F/Admin/BoardPostForm'),
        BoardMaster:   initStaticModule('F/Admin/BoardMaster'),        // 게시판 마스터 (/adm/board · 글관리 '게시판관리' 모달)
        ManagerEditForm: initStaticModule('F/Admin/ManagerEditForm'),   // 관리자 등록/수정 모달 (관리자 목록)
        CmsMembers:      initStaticModule('F/Admin/CmsMembers'),        // CMS 회원 리스트 모달 (CMS 관리)
        OrderPushSend:   initStaticModule('F/Admin/OrderPushSend'),     // 접수목록 [푸시/불러톡] 모달   // 게시판 글 작성/수정 폼 — 글 관리 우측 패널·단독 편집 공용
    },
    Devil: {
        Render:   initModule('F/Devil/Render'),   // 공용 렌더(프리미티브·제보자카드·통화목록·마스터상세)
        Master:   initModule('F/Devil/Master'),   // 업체 상세 BS opener (구 openMasterBS)
        MyReport: initModule('F/Devil/MyReport'), // 내제보건 상세 BS opener (My 리스트에서 호출)
        Notice:   initModule('F/Devil/Notice'),   // 공지사항 BS (구 openNoticeBS)
        Settings: initModule('F/Devil/Settings'), // 체불번호감지/통화이력공유 BS (구 openCallBlockBS/openCallShareBS)
        Terms:    initModule('F/Devil/Terms'),    // 약관 및 권한 안내 BS
        DevBridge: initModule('F/Devil/DevBridge'), // 서버(도메인) 전환 BS (상단 타이틀 7연속 탭 진입)
        App:      initModule('F/Devil/App'),      // 악덕알리미 앱(BD) 연동 흐름 — 설정 동기화·마스터 토글 (브리지는 $j.F.App)
    }
};

// $j.F.Android — $j.F.App 의 영구 별칭. 지우지 않는다: 설치된 앱(안드로이드)이
// `$j.F.Android.callbackBroker(...)` 를 코드에 박아 두고 있고 옛 버전은 몇 년씩 남는다.
// getter 라서 $j.reset('F.App') 으로 인스턴스가 바뀌어도 같은 객체를 가리키고,
// enumerable:false 라 indexModules 가 같은 모듈을 두 번 세지 않는다.
Object.defineProperty($j.F, 'Android', {
    get: () => $j.F.App,
    enumerable: false,
    configurable: false,
});

// ✅ $j 안의 인스턴스 위치를 인덱싱하고, reset/destroy API 제공
$j._swapIndex = new Map(); // key: "Ui.Modal" -> { holder, prop, path }

$j.indexModules = () => {
    $j._swapIndex.clear();

    const seen = new WeakSet();

    const walk = (obj, prefix) => {
        if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) return;
        if (seen.has(obj)) return;
        seen.add(obj);

        for (const key of Object.keys(obj)) {
            const val = obj[key];
            const fullKey = prefix ? `${prefix}.${key}` : key;

            // initModule로 만들어진 인스턴스면 인덱싱
            if (val && typeof val === 'object' && typeof val.__j_path === 'string') {
                $j._swapIndex.set(fullKey, { holder: obj, prop: key, path: val.__j_path });
            }

            // 계속 탐색 (네임스페이스 객체들)
            if (val && (typeof val === 'object' || typeof val === 'function')) {
                walk(val, fullKey);
            }
        }
    };

    walk($j, '$j');
    // "$j.Ui.Modal" 형태로도 쓰기 편하게 별칭 인덱스 추가
    // for (const [k, v] of Array.from($j._swapIndex.entries())) {
    //     if (k.startsWith('$j.')) $j._swapIndex.set(k.slice(3), v); // "Ui.Modal"
    // }
};

// 키값으로 인스턴스 얻기
$j.inst = (key) => {
    const meta = $j._swapIndex.get(key);
    if (!meta) return null;
    return meta.holder[meta.prop];
};
// 인스턴스값으로 키값 얻기
$j.key = (inst) => {
    for (const [key, meta] of $j._swapIndex.entries()) {
        if (meta.holder[meta.prop] === inst) return key;
    }
    return null;
};

// 인스턴스 파기
$j.destroy = (key) => {
    const meta = $j._swapIndex.get(key);
    if (!meta) return;

    const inst = meta.holder[meta.prop];
    if (!inst) return;

    inst.destroy?.();              // 모듈이 제공하면 정리
    meta.holder[meta.prop] = null; // 참조 제거( GC 대상 )
};

// 인스턴스 재생성(교체)
$j.reset = (key) => {
    const meta = $j._swapIndex.get(key);
    if (!meta) throw new Error(`reset failed: not indexed -> ${key}`);

    $j.destroy(key);

    const ModuleClass = require(`./${meta.path}`).default;
    const inst = new ModuleClass();
    Object.defineProperty(inst, '__j_path', { value: meta.path, enumerable: false });

    meta.holder[meta.prop] = inst;
    return inst;
};

/**
 * 인스턴스를 기준으로 $j 네임스페이스상의 경로 키를 반환한다.
 *
 * 예)
 *   $j.F.Car === inst  →  "F.Car"
 *
 * 용도:
 * - 모듈 내부에서 자신의 논리적 위치를 알고 싶을 때
 * - 디버깅 / 로그 / 에러 메시지
 * - reset, destroy 대상 식별
 *
 * 동작 방식:
 * - $j.indexModules() 에 의해 생성된 _swapIndex(Map)를 순회
 * - holder[prop] === inst 인 항목을 찾으면 해당 key 반환
 *
 * 주의:
 * - 동일 인스턴스가 여러 경로에 바인딩되면 첫 번째 키만 반환됨
 * - O(n) 탐색이지만 모듈 수가 많지 않으면 성능 문제 없음
 *
 * @param {Object} inst - initModule()로 생성된 모듈 인스턴스
 * @returns {string|null} "F.Car" 형태의 키, 없으면 null
 */
$j.getNS = (inst) => {
    for (const [key, meta] of $j._swapIndex.entries()) {
        // 실제 네임스페이스 객체의 참조와 인스턴스가 동일한지 비교
        if (meta.holder[meta.prop] === inst) {
            return key; // "F.Car"
        }
    }
    return null;
};

$j.Pages = {};

/**
 * 페이지 모듈 동적 로드.
 *
 * ⚠ 모듈이 '없는 것'은 오류가 아니다 — data-page-name 은 JS 모듈 이름 전용이 아니라
 *   다크모드·글자크기 화이트리스트 키(config/theme.php)이자 리뉴얼 팔레트 스코프
 *   (sass abstracts/_renewal.scss)로도 쓰인다. 그래서 JS 가 blade 인라인에만 있는 화면
 *   (SettingMy·Notice·Menu·AccountDeposit …)도 이름을 갖고, 여기 import 는 당연히 빈손으로 돌아온다.
 *   그걸 console.error 로 찍으면 정상 화면마다 빨간 줄이 남아 진짜 오류가 묻힌다.
 *
 * 그래서 두 경우를 가른다 —
 *   MODULE_NOT_FOUND : 모듈 없음(정상) → debug 로만 남긴다
 *   그 외             : 모듈은 있는데 로드/생성자에서 터짐(진짜 오류) → error 로 남긴다
 */
$j.loadPageModule = async (pageType, pageName) => {
    try {
        const module = await import(`./Pages/${pageType}/${pageName}`);
        if (!$j.Pages[pageType]) {
            $j.Pages[pageType] = {};
        }
        const inst = new module.default();

        // ✅ 인스턴스에 모듈 경로 태깅(열거 안 되게)
        const path = `Pages/${pageType}/${pageName}`;
        Object.defineProperty(inst, '__j_path', {
            value: path,
            enumerable: false,
            configurable: false
        });

        $j.Pages[pageType][pageName] = inst;

        // ✅ _swapIndex에 등록
        const fullKey = `Pages.${pageType}.${pageName}`;
        $j._swapIndex.set(fullKey, {
            holder: $j.Pages[pageType],
            prop: pageName,
            path: path
        });

        return inst;
    } catch (error) {
        // webpack 이 컨텍스트에 없는 모듈을 요청받으면 code='MODULE_NOT_FOUND' 인 Error 를 던진다.
        if (error && error.code === 'MODULE_NOT_FOUND') {
            console.debug(`No page module (blade 인라인 JS 화면): ${pageType}/${pageName}`);
        } else {
            console.error(`Failed to load page module: ${pageType}/${pageName}`, error);
        }
        return null;
    }
};

$j.indexModules();

// 통계 ajax 로딩 오버레이 — /adm/ajax/stat/ 한정. 캐시 히트(빠름)엔 안 뜨도록 200ms 지연.
(function () {
    let active = 0, timer = null;
    const isStat = (s) => s && typeof s.url === 'string' && s.url.indexOf('/adm/ajax/stat/') === 0;
    $(document).ajaxSend(function (e, xhr, s) {
        if (!isStat(s)) return;
        if (active === 0) timer = setTimeout(() => $j.Common.Util.loadingOverlay(true), 200);
        active++;
    });
    $(document).ajaxComplete(function (e, xhr, s) {
        if (!isStat(s)) return;
        active = Math.max(0, active - 1);
        if (active === 0) {
            if (timer) { clearTimeout(timer); timer = null; }
            $j.Common.Util.loadingOverlay(false);
        }
    });
})();

// DOM 로드 후 페이지 모듈 초기화
$(document).ready(async function () {
    // 시스템 공통 오버레이(네트워크 배너·에러박스·페이지이동 로딩) 주입.
    // 소스보기 비노출 + Bootstrap 의 Network.start()/Layout.showMemberStatusBanner() 소비자보다 먼저 보장.
    $j.Common.SystemUi.inject();
    // 한 번 더 — 페이지가 mobiscroll 을 main.js 뒤에 다시 로드하면 전역 옵션이 새 객체로 초기화된다.
    // 전역 옵션을 바꾸면 이미 만든 달력에도 반영된다.
    $j.Common.Mobiscroll.applyDefaults();

    const pageType = document.body.dataset.pageType; // 'Mobile' 또는 'Admin' 또는 'Devil'
    const pageName = document.body.dataset.pageName; // 페이지 이름 (예: 'Alim', 'Soojoo' 등)

    // 1) 사이트 부트스트랩 실행
    if( pageType ) {
        var Boot = loadSiteBootstrap(pageType);
        Boot && typeof Boot.initialize === 'function' && Boot.initialize();
    }

    // 2) 페이지 모듈 로드/실행
    if (pageType && pageName) {
        const pageModule = await $j.loadPageModule(pageType, pageName);
        if (pageModule && typeof pageModule.initialize === 'function') {
            pageModule.initialize();
            $j.p = pageModule; // ✅ 현재 페이지 모듈에 접근하기위한 변수로 $j.p 를 지정
        }
    }
});

export default $j;
